// extracted by mini-css-extract-plugin
module.exports = {"vertical":"_2JieuxcITu3dMYhr7kxDZR","horizontal":"_2lxpU6cfqnDHmvq6cNYaJA"};